import { render, staticRenderFns } from "./ques42.vue?vue&type=template&id=2d0b7ac9&scoped=true"
import script from "./ques42.vue?vue&type=script&lang=js"
export * from "./ques42.vue?vue&type=script&lang=js"
import style0 from "./ques42.vue?vue&type=style&index=0&id=2d0b7ac9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b7ac9",
  null
  
)

export default component.exports